import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nom "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Slug "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Marchand "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_13 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Marchand "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Description du produit "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "card mb-25 border-0 rounded-0 bg-white single-product-box" }
const _hoisted_23 = { class: "card-body p-0 letter-spacing" }
const _hoisted_24 = { class: "image position-relative" }
const _hoisted_25 = { class: "d-block" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "content p-20 d-flex justify-content-center" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "product-upload mb-10" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "Images", -1)
const _hoisted_36 = { class: "dz-message needsclick" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_39 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_42 = { class: "col-md-2" }
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Quantité "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_45 = { class: "col-md-2" }
const _hoisted_46 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Quantité rupture ", -1)
const _hoisted_48 = { class: "col-md-2" }
const _hoisted_49 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Numéro de série ", -1)
const _hoisted_51 = { class: "col-md-2" }
const _hoisted_52 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Prix de vente"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Couleur "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Prix d'achat ", -1)
const _hoisted_60 = { class: "col-md-3" }
const _hoisted_61 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Seuil alerte ", -1)
const _hoisted_63 = { class: "col-md-3" }
const _hoisted_64 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Prix promo "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_66 = { class: "col-md-3" }
const _hoisted_67 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Poids (kg)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_69 = { class: "col-md-3" }
const _hoisted_70 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Marque "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_72 = { class: "col-md-3" }
const _hoisted_73 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Modèle "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_75 = { class: "col-md-3" }
const _hoisted_76 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Taille "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_78 = { class: "col-md-12" }
const _hoisted_79 = { class: "d-flex align-items-center" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Modifier un produit ", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_83 = {
  class: "modal fade createNewModal",
  id: "AddImageModal",
  tabindex: "-1",
  ref: "addAddImageModalRef",
  "aria-hidden": "true"
}
const _hoisted_84 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_85 = { class: "modal-content p-15 p-md-40" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Image actuelle")
], -1)
const _hoisted_87 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25 text-center" }
const _hoisted_88 = ["src"]
const _hoisted_89 = { key: 1 }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          ref: "produitForm",
          onSubmit: _ctx.editProduit,
          "validation-schema": _ctx.produitSchema,
          "initial-values": _ctx.produitForm
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_Field, {
                    name: "title",
                    type: "text",
                    modelValue: _ctx.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le nom"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "title",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_Field, {
                    name: "slug",
                    type: "text",
                    readonly: "true",
                    modelValue: _ctx.slug,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.slug) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "slug",
                    class: "text-danger"
                  })
                ])
              ]),
              (_ctx.estMarchand)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_Field, {
                        name: "marchand",
                        modelValue: _ctx.userName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userName) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black input-readonly",
                        readonly: "true"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "marchand",
                        class: "text-danger"
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.march,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.march) = $event)),
                        name: "marchand"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.marchandOptions,
                            searchable: true,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            onSelect: ($event: any) => (_ctx.selectMarchand(field.value)),
                            placeholder: "Sélectionner le marchand"
                          }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "marchand",
                        class: "text-danger"
                      })
                    ])
                  ])),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_QuillEditor, {
                      ref: "descriptionEditor",
                      theme: "snow",
                      placeholder: "Écrire la description",
                      toolbar: "full",
                      name: "description"
                    }, null, 512)
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "description",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fichiers, (fiche, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-2 shadow-none lh-1 fw-medium text-black-emphasis",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("a", _hoisted_25, [
                              _createElementVNode("img", {
                                src: _ctx.getUrlApiForProductFiles(fiche.name),
                                alt: "Image",
                                style: {"filter":"invert(0)"}
                              }, null, 8, _hoisted_26)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("a", {
                              class: "badge badge-outline-danger text-outline-primary mx-2 justify-content-center",
                              href: "#",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#AddImageModal",
                              onClick: ($event: any) => (_ctx.showImage(_ctx.getUrlApiForProductFiles(fiche.name)))
                            }, _hoisted_30, 8, _hoisted_28),
                            _createElementVNode("a", {
                              class: "badge badge-outline-danger text-danger text-outline-primary mx-2 justify-content-center",
                              type: "button",
                              onClick: ($event: any) => (_ctx.supprimerFichierParId(fiche.id))
                            }, _hoisted_33, 8, _hoisted_31)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_DropZone, {
                      name: "fichiers[]",
                      maxFilesize: 5000,
                      maxFiles: Number(10000000000),
                      uploadOnDrop: true,
                      multipleUpload: true,
                      parallelUpload: 3,
                      filesizeBase: 5000,
                      onThumbnail: _ctx.onThumbnail,
                      onComplete: _ctx.onComplete,
                      onAddedFile: _ctx.onFileAdd,
                      ref: "dropzoneRef"
                    }, null, 8, ["maxFiles", "onThumbnail", "onComplete", "onAddedFile"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, [
                    _createTextVNode(" Image principale"),
                    _hoisted_40,
                    _createElementVNode("a", {
                      style: {"float":"right"},
                      class: "badge badge-outline-danger text-outline-primary",
                      href: "#",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#AddImageModal",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showImage(_ctx.getUrlApiForProductFiles(_ctx.produit.urlImage))))
                    }, [
                      _createTextVNode(" Voir l'image "),
                      _hoisted_41
                    ])
                  ]),
                  _createVNode(_component_Field, {
                    name: "urlImage",
                    type: "file",
                    accept: "image/jpeg, image/png application/pdf",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Choisir une image"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "urlImage",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_Field, {
                    name: "depot",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer la quantité"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "depot",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createVNode(_component_Field, {
                    name: "quantiteRupture",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer la quantité de rupture"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "quantiteRupture",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(_component_Field, {
                    name: "numeroSerie",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le numéro de série"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "numeroSerie",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode(_component_Field, {
                    name: "price",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le prix de vente"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "price",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createVNode(_component_Field, { name: "couleur" }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: _ctx.couleurOptions,
                        searchable: true,
                        "track-by": "label",
                        label: "label",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Sélectionner la couleur" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "couleur",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createVNode(_component_Field, {
                    name: "prixAchat",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le prix d'achat"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "prixAchat",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createVNode(_component_Field, {
                    name: "seuilAlerte",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le seuil"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "seuilAlerte",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode(_component_Field, {
                    name: "sale_price",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le nouveau prix"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "sale_price",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _createVNode(_component_Field, {
                    name: "poids",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le poids"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "poids",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createVNode(_component_Field, {
                    name: "marque",
                    modelValue: _ctx.marque,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.marque) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: _ctx.marqueOptions,
                        searchable: true,
                        "track-by": "label",
                        label: "label",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Sélectionner la marque" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "marque",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _createVNode(_component_Field, { name: "model" }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: _ctx.modeleOptions,
                        searchable: true,
                        "track-by": "label",
                        label: "label",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Sélectionner le modèle" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "model",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createVNode(_component_Field, { name: "taille" }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: _ctx.tailleOptions,
                        searchable: true,
                        "track-by": "label",
                        label: "label",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Sélectionner la taille" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "taille",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _createVNode(_component_router_link, {
                    to: "/liste-produits",
                    class: "btn btn-danger transition border-0 lh-1 fw-medium"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_81,
                      _hoisted_82,
                      _createTextVNode("Annuler")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"])
      ])
    ]),
    _createElementVNode("div", _hoisted_83, [
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _hoisted_86,
          _createElementVNode("div", _hoisted_87, [
            (_ctx.urlAffichage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.urlAffichage,
                  alt: "Image"
                }, null, 8, _hoisted_88))
              : (_openBlock(), _createElementBlock("h3", _hoisted_89, "Aucune image"))
          ]),
          _hoisted_90
        ])
      ])
    ], 512)
  ], 64))
}